import { z } from "zod";

/**
 * Sessao autenticada — identidade do token, sem o segredo.
 */
export const sessaoSchema = z.object({
  sujeito: z.string().min(1),
  cliente: z.string().min(1),
  escopos: z.array(z.string()),
  emissor: z.string().min(1),
  tenantId: z.string().min(1),
  email: z.string().email().optional(),
  nome: z.string().min(1).optional(),
});

export const loginSchema = z.object({
  email: z.string().trim().email(),
  senha: z.string().min(8).max(200),
});

export const loginRespostaSchema = z.object({
  token: z.string().min(24),
  sessao: sessaoSchema,
});

export const trocarTenantSchema = z.object({
  tenantId: z.string().uuid(),
});

export const trocarTenantRespostaSchema = z.object({
  sessao: sessaoSchema,
});

export type Sessao = z.infer<typeof sessaoSchema>;
export type Login = z.infer<typeof loginSchema>;
export type LoginResposta = z.infer<typeof loginRespostaSchema>;
export type TrocarTenantCorpo = z.infer<typeof trocarTenantSchema>;
export type TrocarTenantResposta = z.infer<typeof trocarTenantRespostaSchema>;
